import { useContext, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import SaleBanner from '@wix/da-shared-react/pkg/banners/SaleBanner';
import { useCurrentPromo } from '@wix/da-shared-react/pkg/utils/hooks/useCurrentPromo';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData, ManageInStudioClickBiEvent } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ManageImagesIcon from '@wix/da-ds/pkg/Icons/16x16/ManageImages';
import { Url } from '@wix/da-url';

import s from './MaybeABanner.scss';

export interface Props {
  className?: string;
}

/**
 * Will render a context appropriate banner on desktop if necessary.
 */
const MaybeABanner: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const currentPromo = useCurrentPromo('self');
  const isMobile = useContext(MobileContext);

  if (isMobile) {
    return null;
  }

  if (!currentPromo) {
    return (
      <div className={c(s['studio-banner'], className)}>
        <TextButton
          href={Url.studio({ playground: 'dreamup' })}
          size="medium"
          variant="edit-purple"
          icon={ManageImagesIcon}
          biData={BiData<ManageInStudioClickBiEvent>({
            evid: 15,
            link_name: t('dreamup.banner.studio.text'),
            link_url: Url.studio({ playground: 'dreamup' }),
            sectionname: 'dreamup',
          })}
        >
          {t('dreamup.banner.studio.text')}
        </TextButton>
      </div>
    );
  }

  return (
    <SaleBanner
      className={className}
      giftRecipient={undefined}
      discountValuePercent={currentPromo?.discountValuePercent}
      endDate={currentPromo?.endDate}
      referralType={ReferralType.PROMOTION_BANNER_DREAMUP}
    />
  );
};

MaybeABanner.displayName = 'MaybeABanner';

export default MaybeABanner;
